module.exports = __webpack_public_path__ + "static/img/ljzymj.d7a79f5c.png";